<template>
    <rkm-modal
        ref="RkmModal"
        title="Local de atendimento"
        extra-large
    >
        <rkm-form
            v-if="model"
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="data.form.unidades"
                        :validations="validations.unidade"
                        @change="handleUnidadeChange"
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        :options="data.form.infraestruturas"
                        :validations="validations.infraestrutura"
                        label="Local de atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="model.infraestruturaId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="include"
                color="primary"
            >
                Incluir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                unidade: {required: true},
                infraestrutura: {required:true},
            }
        },
    },
    created() {
        this.repositories = {
            parametrizacao: this.getConectaSusRepository('ambulatorio.parametrizacao'),
        }
    },
    data: () => ({
        model: {
            unidadeId: null,
            infraestruturaId: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open() {
            this.resetForm()
            this.$refs.RkmModal.show()
        },
        handleUnidadeChange(value) {
            this.data.form.infraestruturas = []
            this.model.infraestruturaId = null

            if (value === null) return

            const request = {
                origem: 'infraestrutura',
                listar: 'infraestruturas',
                unidadeId: value,
            }

            this.setLoading()

            this.repositories.parametrizacao.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.data.form.infraestruturas = response.data

                    if (response.data.length === 1) {
                        this.model.infraestruturaId = response.data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        include() {
            if (this.data.model.infraestruturas.find(infraestrutura => infraestrutura.id === this.model.infraestruturaId && infraestrutura.deleted === false)) {
                this.showValidationNotification('O local de atendimento já foi incluído.')
                return
            }

            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    const unidade = this.data.form.unidades.find(unidade => unidade.id === this.model.unidadeId)
                    const infraestrutura = this.data.form.infraestruturas.find(infraestrutura => infraestrutura.id === this.model.infraestruturaId)

                    this.data.model.infraestruturas.push({
                        id: infraestrutura.id,
                        unidadeNomeFantasia: unidade.nomeFantasia,
                        nome: infraestrutura.nome,
                        enviaSms: false,
                        faturaProcedimentoRaas: false,
                        ocupacoes: [],
                        especialidades: [],
                        infraestruturasAgendadoras: [],
                        servicos: [],
                        sms: {
                            diaAntecedencia: null,
                            periodoEnvio: {
                                start: null,
                                end: null,
                            },
                            especialidades: [],
                        },
                        deleted: false,
                    })

                    this.$refs.RkmModal.hide()
                })
        },
        resetForm() {
            this.data.form.infraestruturas = []
            this.model.unidadeId = null
            this.model.infraestruturaId = null

            this.$nextTick().then(() => this.$refs.RkmForm.resetValidator())
        },
    },
    mixins: [error, repository, stringCase],
    props: {
        data: {required: true, type: Object},
    },
}
</script>